<div class="vf-body template16">
  <div class="container">
    <div class="template_vf">

      <!-- Dynamic template name badge -->
      <div class="vf-type-badge">{{ templateName }}</div>

      <!-- HERO: spotlight + profile photo -->
      <section class="vf-hero">
        <div class="vf-glow"></div>
        <div class="vf-avatar">
          <img class="vf-hero-photo" [src]="imageSrc" alt="profileImage" />

          <!-- video ho to play button videos tak scroll karta hai -->
          <a
            class="vf-play"
            role="button"
            tabindex="0"
            title="Watch videos"
            (click)="vfv.scrollIntoView({ behavior: 'smooth' })"
            *ngIf="
              (youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) ||
              (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) ||
              (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)
            "
          >
            <i class="fa-solid fa-play"></i>
          </a>
        </div>
      </section>

      <!-- Name + title -->
      <section class="vf-name-block">
        <h1>{{ firstName + ' ' + lastName }}</h1>
        <p>{{ jobTitle }}<span *ngIf="companyName"> · {{ companyName }}</span></p>
      </section>

      <!-- Social buttons: YouTube / Instagram / Pinterest / LinkedIn -->
      <section class="vf-social" *ngIf="youtube || instagram || pinterest || linkedin">
        <a [href]="youtube" target="_blank" *ngIf="youtube" class="vf-social-youtube">
          <i class="fa-brands fa-youtube"></i><span>YouTube</span>
        </a>
        <a [href]="instagram" target="_blank" *ngIf="instagram" class="vf-social-instagram">
          <i class="fa-brands fa-instagram"></i><span>Instagram</span>
        </a>
        <a [href]="pinterest" target="_blank" *ngIf="pinterest" class="vf-social-pinterest">
          <i class="fa-brands fa-pinterest-p"></i><span>Pinterest</span>
        </a>
        <a [href]="linkedin" target="_blank" *ngIf="linkedin" class="vf-social-linkedin">
          <i class="fa-brands fa-linkedin-in"></i><span>LinkedIn</span>
        </a>
      </section>

      <!-- About text -->
      <section class="vf-about" [innerHTML]="content"></section>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="vf-videos" #vfv>

        <div
          class="vf-sec-title"
          *ngIf="
            (youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) ||
            (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) ||
            (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)
          "
        >
          <i class="fa-solid fa-circle-play"></i> Watch
        </div>

        <!-- YouTube -->
        <ng-container *ngFor="let v of youtubeArray">
          <div class="vf-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="vf-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="vf-embed">
              <iframe
                class="vf-hero-video"
                [src]="src"
                [title]="v.youtubeTitle || 'YouTube player'"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </ng-container>

        <!-- Umyotube -->
        <ng-container *ngFor="let v of umyotubeArray">
          <div class="vf-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="vf-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="vf-embed">
              <iframe
                class="vf-hero-video"
                [src]="src"
                title="Umyotube player"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </ng-container>

        <!-- Vimeo -->
        <ng-container *ngFor="let v of vimeoArray">
          <div class="vf-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="vf-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="vf-embed">
              <iframe
                class="vf-hero-video"
                [src]="src"
                [title]="v.vimeoVideoTitle || 'Vimeo player'"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </ng-container>

        <!-- koi video na ho to placeholder -->
        <div
          class="vf-hero-placeholder"
          *ngIf="
            !(
              (youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) ||
              (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) ||
              (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)
            )
          "
        >
          <img class="vf-hero-photo" src="assets/images/template-img-001.jpg" alt="No video placeholder" />
          <div class="vf-play-btn"><i class="fa-solid fa-play"></i></div>
        </div>
      </section>

      <!-- Pill buttons (ab video ke neeche) -->
      <section class="vf-buttons">

        <!-- REAL LINK BUTTONS AVAILABLE -->
        <ng-container
          *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle; else demoButtons"
        >
          <a
            *ngFor="let button of buttons"
            [href]="button.LinkButtonLink"
            target="_blank"
            class="vf-btn"
            [style.background-color]="buttonColor"
          >
            <i class="fa-solid fa-link"></i>
            {{ button.LinkButtonTitle }}
          </a>
        </ng-container>

        <!-- DEMO BUTTONS WHEN NO REAL BUTTONS EXIST -->
        <ng-template #demoButtons>
          <a href="#" class="vf-btn vf-btn-primary" [style.background-color]="buttonColor" (click)="$event.preventDefault()">
            <i class="fa-solid fa-play"></i>
            Watch My Latest Video
          </a>
          <a href="#" class="vf-btn" (click)="$event.preventDefault()">
            <i class="fa-brands fa-spotify"></i>
            Listen on Spotify
          </a>
          <a href="#" class="vf-btn" (click)="$event.preventDefault()">
            <i class="fa-solid fa-headphones"></i>
            Listen on Apple Music
          </a>
          <a href="#" class="vf-btn" (click)="$event.preventDefault()">
            <i class="fa-brands fa-youtube"></i>
            Follow on YouTube
          </a>
        </ng-template>

      </section>

      <!-- Facebook (pehle social row mein tha) -->
      <section class="vf-more" *ngIf="facebook">
        <a [href]="facebook" target="_blank" class="vf-social-facebook">
          <i class="fa-brands fa-facebook-f"></i> Facebook
        </a>
      </section>

      <!-- Contact row -->
      <section class="vf-contact">
        <a [href]="'tel:' + phone"><i class="fa-solid fa-phone"></i></a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow"><i class="fa-solid fa-comments"></i></a>
        <a [href]="'mailto:' + email"><i class="fa-solid fa-envelope"></i></a>
      </section>

      <div class="vf-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer>
        <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code"  style="width: 120px;" />
        <p class="vf-strip">Watch <i></i> Listen <i></i> Connect</p>
        <p class="mt-3">This card is powered by <span>UMYO Cards</span></p>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>